// Placeholder so `require.context('./screens')` (in i18n.ts) always resolves,
// even before per-screen namespace files exist. Each C-screen drops its own
// `<name>.js` here exporting `{ ar: {...}, en: {...} }`, merged at load time —
// so screens own their i18n without touching the shared vivo-messages.js.
module.exports = { ar: {}, en: {} };
